import React, { useState } from 'react';
import { sendContactMessage } from '../../api/contact';
import { ToastContainer, useToast } from '../common/Toast';

export default function HomeContact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [description, setDescription] = useState('');
  const [status, setStatus] = useState('idle');
  const { toast, showToast, dismissToast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    try {
      await sendContactMessage({
        name: name.trim(),
        email: email.trim(),
        description: description.trim(),
        source: 'home',
      });
      setName('');
      setEmail('');
      setDescription('');
      setStatus('idle');
      showToast('Thanks—your message was sent. We will get back to you when we can.', 'success');
    } catch (err) {
      showToast(err instanceof Error ? err.message : 'Could not send message.', 'error');
      setStatus('idle');
    }
  };

  return (
    <section className="bg-slate-50 py-16 sm:py-20 lg:py-24" aria-labelledby="home-contact-heading">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-semibold uppercase tracking-wide text-brand-700">Contact</p>
          <h2
            id="home-contact-heading"
            className="mt-2 text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl"
          >
            Get in touch
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-600">
            Send us a message—we read every submission and reply when we can.
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="mx-auto mt-10 w-full max-w-4xl rounded-2xl border border-slate-200/80 bg-white p-6 shadow-sm ring-1 ring-slate-200/60 sm:p-8"
          aria-busy={status === 'loading'}
        >
          <div className="space-y-5">
            <div>
              <label htmlFor="home-contact-name" className="block text-sm font-medium text-slate-900">
                Name
              </label>
              <input
                id="home-contact-name"
                name="name"
                type="text"
                autoComplete="name"
                required
                value={name}
                onChange={(ev) => setName(ev.target.value)}
                disabled={status === 'loading'}
                className="mt-1.5 block w-full rounded-md border border-slate-300 px-3 py-2 text-slate-900 shadow-sm placeholder:text-slate-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 disabled:opacity-60"
                placeholder="Your name"
              />
            </div>
            <div>
              <label htmlFor="home-contact-email" className="block text-sm font-medium text-slate-900">
                Email id
              </label>
              <input
                id="home-contact-email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(ev) => setEmail(ev.target.value)}
                disabled={status === 'loading'}
                className="mt-1.5 block w-full rounded-md border border-slate-300 px-3 py-2 text-slate-900 shadow-sm placeholder:text-slate-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 disabled:opacity-60"
                placeholder="you@example.com"
              />
            </div>
            <div>
              <label htmlFor="home-contact-description" className="block text-sm font-medium text-slate-900">
                Description
              </label>
              <textarea
                id="home-contact-description"
                name="description"
                rows={5}
                required
                value={description}
                onChange={(ev) => setDescription(ev.target.value)}
                disabled={status === 'loading'}
                className="mt-1.5 block w-full resize-y rounded-md border border-slate-300 px-3 py-2 text-slate-900 shadow-sm placeholder:text-slate-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 disabled:opacity-60"
                placeholder="How can we help?"
              />
            </div>
          </div>
          <div className="mt-8 flex justify-center">
            <button
              type="submit"
              disabled={status === 'loading'}
              className="inline-flex w-full items-center justify-center rounded-md bg-brand-500 px-6 py-3 text-sm font-semibold text-white shadow-md shadow-brand-900/15 transition hover:bg-brand-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500 enabled:cursor-pointer disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto"
            >
              {status === 'loading' ? 'Sending…' : 'Send message'}
            </button>
          </div>
        </form>
      </div>
      <ToastContainer toast={toast} onDismiss={dismissToast} />
    </section>
  );
}
